import {
  BookWidgetAem,
  BookWidgetFields
} from '@com-delta-idp/mnx-capability-flight-shop-ui';
import { BookWidgetFieldsMasterConfig } from '../../models/book-widget-fields-master-config.interfaces';
import { CatalogApiFieldsValue } from '../../models/core-apis/catalog-api.interfaces';
import { RetrieveSearchData } from '../../models/core-apis/retrieve-search.interfaces';
import { bookWidgetFieldsRulesOnInitEval } from '../book-widget-fields-rules/on-init/book-widget-fields-rules-on-init.adapter';
import { updateAirportsFieldFromRecentSearch } from './recent-search-airports-field.adapter';
import { updateBasicFaresFieldFromRecentSearch } from './recent-search-basic-fares-field.adapter';
import { updateBestFareFieldFromRecentSearch } from './recent-search-best-fare-field-adapter';
import { updateDatesFieldFromRecentSearch } from './recent-search-dates-field.adapter';
import { updateFlexAirportFieldFromRecentSearch } from './recent-search-flex-airport-field.adapter';
import { updateFlexDatesFieldFromRecentSearch } from './recent-search-flex-dates-field.adapter';
import { updateMeetingEventCodeFieldFromRecentSearch } from './recent-search-meeting-event-code-field.adapter';
import { updatePassengerFieldFromRecentSearch } from './recent-search-passenger-field.adapter';
import { updateRefundableFareFieldFromRecentSearch } from './recent-search-refundable-fare-field.adapter';
import { updateShopMilesFieldFromRecentSearch } from './recent-search-shop-miles-field.adapter';
import { updateTripTypeFieldFromRecentSearch } from './recent-search-trip-type-field.adapter';

export const updateFieldsFromRecentSearch = (
  retrieveSearchDataList: RetrieveSearchData[] | null,
  index: number,
  bookWidgetFields: BookWidgetFields,
  bookWidgetFieldsMasterConfig: BookWidgetFieldsMasterConfig,
  catalogApiFieldsValue: CatalogApiFieldsValue | null,
  bookWidgetAem: BookWidgetAem | null
): BookWidgetFields => {
  let updatedBookWidgetFields = { ...bookWidgetFields };

  if (retrieveSearchDataList?.length) {
    const retrieveSearchData = retrieveSearchDataList[index];

    updatedBookWidgetFields = updateAirportsFieldFromRecentSearch(
      retrieveSearchData,
      updatedBookWidgetFields
    );

    updatedBookWidgetFields = updateTripTypeFieldFromRecentSearch(
      retrieveSearchData,
      updatedBookWidgetFields,
      bookWidgetFieldsMasterConfig
    );

    updatedBookWidgetFields = updateDatesFieldFromRecentSearch(
      retrieveSearchData,
      updatedBookWidgetFields
    );

    updatedBookWidgetFields = updatePassengerFieldFromRecentSearch(
      retrieveSearchData,
      updatedBookWidgetFields,
      bookWidgetFieldsMasterConfig
    );

    updatedBookWidgetFields = updateShopMilesFieldFromRecentSearch(
      retrieveSearchData,
      updatedBookWidgetFields,
      bookWidgetFieldsMasterConfig
    );

    updatedBookWidgetFields = updateRefundableFareFieldFromRecentSearch(
      retrieveSearchData,
      updatedBookWidgetFields,
      bookWidgetFieldsMasterConfig
    );

    updatedBookWidgetFields = updateFlexDatesFieldFromRecentSearch(
      retrieveSearchData,
      updatedBookWidgetFields,
      bookWidgetFieldsMasterConfig
    );

    updatedBookWidgetFields = updateBasicFaresFieldFromRecentSearch(
      retrieveSearchData,
      updatedBookWidgetFields,
      bookWidgetFieldsMasterConfig,
      catalogApiFieldsValue,
      bookWidgetAem
    );

    updatedBookWidgetFields = updateFlexAirportFieldFromRecentSearch(
      retrieveSearchData,
      updatedBookWidgetFields,
      bookWidgetFieldsMasterConfig
    );

    updatedBookWidgetFields = updateBestFareFieldFromRecentSearch(
      retrieveSearchData,
      updatedBookWidgetFields,
      bookWidgetFieldsMasterConfig
    );

    updatedBookWidgetFields = updateMeetingEventCodeFieldFromRecentSearch(
      retrieveSearchData,
      updatedBookWidgetFields,
      bookWidgetFieldsMasterConfig
    );

    //Init rules applies here. In case there are exceptions then create separate rule adapter to avoid impact on init
    updatedBookWidgetFields = bookWidgetFieldsRulesOnInitEval(
      updatedBookWidgetFields,
      bookWidgetFieldsMasterConfig
    );
  }

  return updatedBookWidgetFields;
};
